import React from 'react';
import '../css/Footer.css'; // Make sure this CSS exists
import logo from '../resources/topLogo.png'; // Update path if needed
import { MapPin, Phone, Mail } from 'lucide-react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img src={logo} alt="PortMatch Logo" className="footer-logo" />
          <h2>PortMatch</h2>
          <p>Your trusted gateway to smarter sea freight.</p>
        </div>
        <div className="footer-middle">
          <h3>Contact Us</h3>
          <p><MapPin size={16} color="#2563eb" style={{ marginRight: '8px' }} /> 123 Ocean Drive, Tradeport City, USA</p>
          <p><Phone size={16} color="#2563eb" style={{ marginRight: '8px' }} /> +1 (800) 555-SEA1</p>
          <p><Mail size={16} color="#2563eb" style={{ marginRight: '8px' }} /> business@portmatch.com</p>
        </div>
        <div className="footer-right">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} PortMatch Inc. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
